import { Amplify } from "aws-amplify";
import {
  signIn,
  signUp,
  confirmSignUp as confirmSignUpOriginal,
  resetPassword,
  confirmResetPassword,
  signOut,
  getCurrentUser as getCurrentUserOriginal,
} from "@aws-amplify/auth";

// Configuration for AWS Cognito using the provided user pool
export const cognitoConfig = {
  region: "us-east-1",
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
};

// Initialize AWS Amplify with Cognito configuration
export const initializeCognito = () => {
  if (!cognitoConfig.userPoolWebClientId) {
    console.warn("Cognito client ID not provided in environment variables");
    return false;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        region: cognitoConfig.region,
        userPoolId: cognitoConfig.userPoolId,
        userPoolClientId: cognitoConfig.userPoolWebClientId,
      },
    },
  });

  return true;
};

// Re-export getCurrentUser for use in AuthContext
export const getCurrentUser = getCurrentUserOriginal;

// Initialize Cognito if configured
if (process.env.REACT_APP_COGNITO_CLIENT_ID) {
  initializeCognito();
}

// Create a Cognito auth object with similar interface to Firebase
const auth = {
  // Core methods used by app
  signInWithEmailAndPassword: (email, password) =>
    signIn({ username: email, password }),

  createUserWithEmailAndPassword: (email, password, userAttributes) =>
    signUp({
      username: email,
      password,
      options: { userAttributes },
    }),

  sendPasswordResetEmail: (email) => resetPassword({ username: email }),

  confirmPasswordReset: (code, newPassword, email) =>
    confirmResetPassword({
      username: email,
      confirmationCode: code,
      newPassword,
    }),

  confirmSignUp: (email, code) =>
    confirmSignUpOriginal({ username: email, confirmationCode: code }),

  signOut: () => signOut(),

  currentUser: null,
};

export { auth };
